import {
  resolveGalleryBlockId,
  resolveGalleryBlockIdForMutation,
  type WaveDocEditor,
} from "@vida/wave-core";
import {
  inferBlobKind,
  normalizedContentType,
  registerWaveBlobAttachment,
  uploadBlobFile,
} from "./waveBlobUpload";

export { resolveGalleryBlockId, resolveGalleryBlockIdForMutation };

export async function uploadImagesToGalleryBlock(
  editor: WaveDocEditor,
  waveId: string,
  galleryBlockId: string,
  files: File[],
  onError?: (message: string) => void,
): Promise<void> {
  const targetId = resolveGalleryBlockIdForMutation(editor, editor.blocks, galleryBlockId);
  for (const file of files) {
    if (inferBlobKind(file) !== "image") continue;
    const mime = normalizedContentType(file, "image");
    const item = editor.addGalleryItem(targetId, {
      fileName: file.name,
      mimeType: mime,
      fileSize: file.size,
      uploadStatus: "uploading",
    });
    try {
      const result = await uploadBlobFile(file);
      editor.setGalleryItemMeta(targetId, item.id, {
        s3Key: result.s3Key,
        mimeType: mime,
        fileName: file.name,
        fileSize: file.size,
        uploadStatus: "ready",
      });
      try {
        await registerWaveBlobAttachment(waveId, result.s3Key, file.name);
      } catch {
        /* optional */
      }
    } catch (e) {
      editor.setGalleryItemMeta(targetId, item.id, { uploadStatus: "error" });
      onError?.(e instanceof Error ? e.message : "Upload fallito");
    }
  }
}
